import * as React from "react";
import Results from "../containers/Results";

export default (props) =>
  props.activeFotterMenu === 1 && <Results {...props} />;
